import AdminCrudPage from "./AdminCrudPage";

export default function AdminAnnouncement() {
  return (
    <AdminCrudPage
      title="Announcements"
      endpoint="announcements"
      initial={{ title: "", message: "", cta_text: "View Offer", cta_link: "/products", image: "", active: true }}
      columns={[
        { key: "title", label: "Title" },
        { key: "active", label: "Active", render: (it) => it.active ? "Yes — showing on homepage" : "—" },
      ]}
      fields={[
        { name: "title", label: "Title" },
        { name: "message", label: "Message", type: "textarea" },
        { name: "cta_text", label: "Button Text (optional)" },
        { name: "cta_link", label: "Button Link (optional, e.g. /products)" },
        { name: "image", label: "Image (optional)", type: "image" },
        { name: "active", label: "Show on homepage (only one can be active at a time)", type: "boolean" },
      ]}
    />
  );
}
